/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const timeDate = require ('../../../../../js-handler/time-date')

export const tableDetail = {
    entity: 'transaction',//name table on the db
    dest: 'transaction',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" } ],
                                
                                 "clickRight": [{"dest":"transaction", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"transaction", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["transaction.entity","transaction.account"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }
}

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data){ 
    
    console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' }, 
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }] })
        return newData
    }

    data.forEach((elem)=>{

        let textType;

        switch (elem.action) {
            case 'out':
              textType = 'Sent';
              break;

            case 'in':
              textType = 'Received';
              break;

            default:
              break;
        } 


        let elemName    = "";
        let letter      = "";
        let avatarColor = "";
        let avatarColorLetter = "";
        let avatar      = "";

        if (elem.providerAvatar == "" && elem.customerAvatar == "") {
            avatar = "";
            elemName = textType;
            
            // Dividir el nombre en palabras
            let nameParts = elemName.split(" ");

            // Filtrar las palabras para eliminar las que no empiezan con letras (ej. '&')
            let validParts = nameParts.filter(part => /^[A-Za-z]/.test(part));
            
            // Tomar la primera letra de cada palabra (si la palabra existe)
            if (validParts.length > 0) {
                letter += validParts[0].charAt(0); // Primera letra del primer nombre
            }
            if (validParts.length > 1) {
                letter += validParts[1].charAt(0); // Primera letra del segundo nombre
            }
        }else if(elem.customerAvatar == ""){
            avatar   = elem.providerAvatar;
            letter   = elem.providerAvatarLetter;
        }else if(elem.providerAvatar == ""){
            avatar   = elem.customerAvatar;
            letter   = elem.customerAvatarLetter;
        }else{
            //
        }

        if (elem.customerAvatarColor == "" && elem.providerAvatarColor == "") {
            avatarColor = '12af45'
        }else if(elem.customerAvatarColor == ""){
            avatarColor = elem.providerAvatarColor
        }else if(elem.providerAvatarColor == ""){
            avatarColor = elem.customerAvatarColor
        }else{
            //
        }

        if (elem.customerAvatarColorLetter == "" && elem.providerAvatarColorLetter == "") {
            avatarColorLetter = '12af45'
        }else if(elem.customerAvatarColorLetter == ""){
            avatarColorLetter = elem.providerAvatarColorLetter
        }else if(elem.providerAvatarColorLetter == ""){
            avatarColorLetter = elem.customerAvatarColorLetter
        }else{
            //
        }

        newData.push(
            {   id: elem.id,   colum: [  { label: elem.entity,  }, 
                                         { label: elem.accountName  , span: elem.typeUser,  
                                            style:{ 
                                            tdClass:'tdWithAvatar',  
                                            avatar:elem.accountAvatar,
                                                avatarColor: elem.accountAvatarColor, 
                                                avatarColorLetter: elem.accountAvatarColorLetter, 
                                                avatarLetter: elem.accountAvatarLetter  

                                            
                                            }
                                         },
                                         { label: textType, span:'',style:{ 
                                            tdClass:'tdWithAvatar',  
                                            avatar:avatar,
                                            avatarColor: avatarColor, 
                                            avatarColorLetter: avatarColorLetter,
                                            avatarLetter: letter

                                            
                                            }
                                        },
                                         { label: elem.transactionAmount, span: timeDate.friendlyTime(elem.date_time)},
                                         { label: timeDate.friendlyDate(elem.date) , span: timeDate.friendlyTime(elem.date_time)}
                                      ]    
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/